import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as CreateAccountLinkGenericError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { InvalidParameterError as CreateAccountLinkInvalidParameterError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { UnauthorizedError as CreateAccountLinkUnauthorizedError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { ConflictError as CreateAccountLinkConflictError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { InternalServerError as CreateAccountLinkInternalServerError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { BadGatewayError as CreateAccountLinkBadGatewayError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { GatewayTimeoutError as CreateAccountLinkGatewayTimeoutError } from "./types/CreateAccountLink/CreateAccountLinkError";
import { GenericError as CreateAccountTeamLinkGenericError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { InvalidParameterError as CreateAccountTeamLinkInvalidParameterError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { UnauthorizedError as CreateAccountTeamLinkUnauthorizedError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { NotFoundError as CreateAccountTeamLinkNotFoundError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { ConflictError as CreateAccountTeamLinkConflictError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { InternalServerError as CreateAccountTeamLinkInternalServerError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { BadGatewayError as CreateAccountTeamLinkBadGatewayError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { GatewayTimeoutError as CreateAccountTeamLinkGatewayTimeoutError } from "./types/CreateAccountTeamLink/CreateAccountTeamLinkError";
import { GenericError as CreateAccountTeamUserLinkGenericError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { InvalidParameterError as CreateAccountTeamUserLinkInvalidParameterError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { UnauthorizedError as CreateAccountTeamUserLinkUnauthorizedError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { NotFoundError as CreateAccountTeamUserLinkNotFoundError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { ConflictError as CreateAccountTeamUserLinkConflictError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { InternalServerError as CreateAccountTeamUserLinkInternalServerError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { BadGatewayError as CreateAccountTeamUserLinkBadGatewayError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { GatewayTimeoutError as CreateAccountTeamUserLinkGatewayTimeoutError } from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError";
import { GenericError as CreateAccountUserLinkGenericError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { InvalidParameterError as CreateAccountUserLinkInvalidParameterError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { UnauthorizedError as CreateAccountUserLinkUnauthorizedError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { ConflictError as CreateAccountUserLinkConflictError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { InternalServerError as CreateAccountUserLinkInternalServerError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { BadGatewayError as CreateAccountUserLinkBadGatewayError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { GatewayTimeoutError as CreateAccountUserLinkGatewayTimeoutError } from "./types/CreateAccountUserLink/CreateAccountUserLinkError";
import { GenericError as DeleteAccountLinkGenericError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { InvalidParameterError as DeleteAccountLinkInvalidParameterError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { UnauthorizedError as DeleteAccountLinkUnauthorizedError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { NotFoundError as DeleteAccountLinkNotFoundError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { InternalServerError as DeleteAccountLinkInternalServerError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { BadGatewayError as DeleteAccountLinkBadGatewayError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { GatewayTimeoutError as DeleteAccountLinkGatewayTimeoutError } from "./types/DeleteAccountLink/DeleteAccountLinkError";
import { GenericError as DeleteLinkGenericError } from "./types/DeleteLink/DeleteLinkError";
import { InvalidParameterError as DeleteLinkInvalidParameterError } from "./types/DeleteLink/DeleteLinkError";
import { UnauthorizedError as DeleteLinkUnauthorizedError } from "./types/DeleteLink/DeleteLinkError";
import { NotFoundError as DeleteLinkNotFoundError } from "./types/DeleteLink/DeleteLinkError";
import { InternalServerError as DeleteLinkInternalServerError } from "./types/DeleteLink/DeleteLinkError";
import { BadGatewayError as DeleteLinkBadGatewayError } from "./types/DeleteLink/DeleteLinkError";
import { GatewayTimeoutError as DeleteLinkGatewayTimeoutError } from "./types/DeleteLink/DeleteLinkError";
import { GenericError as GetLinkGenericError } from "./types/GetLink/GetLinkError";
import { InvalidParameterError as GetLinkInvalidParameterError } from "./types/GetLink/GetLinkError";
import { UnauthorizedError as GetLinkUnauthorizedError } from "./types/GetLink/GetLinkError";
import { NotFoundError as GetLinkNotFoundError } from "./types/GetLink/GetLinkError";
import { InternalServerError as GetLinkInternalServerError } from "./types/GetLink/GetLinkError";
import { BadGatewayError as GetLinkBadGatewayError } from "./types/GetLink/GetLinkError";
import { GatewayTimeoutError as GetLinkGatewayTimeoutError } from "./types/GetLink/GetLinkError";
import { GenericError as GetTargetGenericError } from "./types/GetTarget/GetTargetError";
import { InvalidParameterError as GetTargetInvalidParameterError } from "./types/GetTarget/GetTargetError";
import { UnauthorizedError as GetTargetUnauthorizedError } from "./types/GetTarget/GetTargetError";
import { NotFoundError as GetTargetNotFoundError } from "./types/GetTarget/GetTargetError";
import { InternalServerError as GetTargetInternalServerError } from "./types/GetTarget/GetTargetError";
import { BadGatewayError as GetTargetBadGatewayError } from "./types/GetTarget/GetTargetError";
import { GatewayTimeoutError as GetTargetGatewayTimeoutError } from "./types/GetTarget/GetTargetError";
import { GenericError as GetTeamLinkGenericError } from "./types/GetTeamLink/GetTeamLinkError";
import { InvalidParameterError as GetTeamLinkInvalidParameterError } from "./types/GetTeamLink/GetTeamLinkError";
import { UnauthorizedError as GetTeamLinkUnauthorizedError } from "./types/GetTeamLink/GetTeamLinkError";
import { NotFoundError as GetTeamLinkNotFoundError } from "./types/GetTeamLink/GetTeamLinkError";
import { InternalServerError as GetTeamLinkInternalServerError } from "./types/GetTeamLink/GetTeamLinkError";
import { BadGatewayError as GetTeamLinkBadGatewayError } from "./types/GetTeamLink/GetTeamLinkError";
import { GatewayTimeoutError as GetTeamLinkGatewayTimeoutError } from "./types/GetTeamLink/GetTeamLinkError";
import { GenericError as GetUserLinkGenericError } from "./types/GetUserLink/GetUserLinkError";
import { InvalidParameterError as GetUserLinkInvalidParameterError } from "./types/GetUserLink/GetUserLinkError";
import { UnauthorizedError as GetUserLinkUnauthorizedError } from "./types/GetUserLink/GetUserLinkError";
import { NotFoundError as GetUserLinkNotFoundError } from "./types/GetUserLink/GetUserLinkError";
import { InternalServerError as GetUserLinkInternalServerError } from "./types/GetUserLink/GetUserLinkError";
import { BadGatewayError as GetUserLinkBadGatewayError } from "./types/GetUserLink/GetUserLinkError";
import { GatewayTimeoutError as GetUserLinkGatewayTimeoutError } from "./types/GetUserLink/GetUserLinkError";
import { GenericError as ListLinksGenericError } from "./types/ListLinks/ListLinksError";
import { UnauthorizedError as ListLinksUnauthorizedError } from "./types/ListLinks/ListLinksError";
import { InternalServerError as ListLinksInternalServerError } from "./types/ListLinks/ListLinksError";
import { BadGatewayError as ListLinksBadGatewayError } from "./types/ListLinks/ListLinksError";
import { GatewayTimeoutError as ListLinksGatewayTimeoutError } from "./types/ListLinks/ListLinksError";
import { GenericError as ListTeamLinksGenericError } from "./types/ListTeamLinks/ListTeamLinksError";
import { InvalidParameterError as ListTeamLinksInvalidParameterError } from "./types/ListTeamLinks/ListTeamLinksError";
import { UnauthorizedError as ListTeamLinksUnauthorizedError } from "./types/ListTeamLinks/ListTeamLinksError";
import { InternalServerError as ListTeamLinksInternalServerError } from "./types/ListTeamLinks/ListTeamLinksError";
import { BadGatewayError as ListTeamLinksBadGatewayError } from "./types/ListTeamLinks/ListTeamLinksError";
import { GatewayTimeoutError as ListTeamLinksGatewayTimeoutError } from "./types/ListTeamLinks/ListTeamLinksError";
import { GenericError as ListUserLinksGenericError } from "./types/ListUserLinks/ListUserLinksError";
import { InvalidParameterError as ListUserLinksInvalidParameterError } from "./types/ListUserLinks/ListUserLinksError";
import { UnauthorizedError as ListUserLinksUnauthorizedError } from "./types/ListUserLinks/ListUserLinksError";
import { InternalServerError as ListUserLinksInternalServerError } from "./types/ListUserLinks/ListUserLinksError";
import { BadGatewayError as ListUserLinksBadGatewayError } from "./types/ListUserLinks/ListUserLinksError";
import { GatewayTimeoutError as ListUserLinksGatewayTimeoutError } from "./types/ListUserLinks/ListUserLinksError";
import { GenericError as LockAccountUserLinkGenericError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
import { InvalidParameterError as LockAccountUserLinkInvalidParameterError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
import { UnauthorizedError as LockAccountUserLinkUnauthorizedError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
import { NotFoundError as LockAccountUserLinkNotFoundError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
import { InternalServerError as LockAccountUserLinkInternalServerError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
import { BadGatewayError as LockAccountUserLinkBadGatewayError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
import { GatewayTimeoutError as LockAccountUserLinkGatewayTimeoutError } from "./types/LockAccountUserLink/LockAccountUserLinkError";
export const errors = {
    CreateAccountLink: {
        InvalidParameterError: CreateAccountLinkInvalidParameterError,
        UnauthorizedError: CreateAccountLinkUnauthorizedError,
        ConflictError: CreateAccountLinkConflictError,
        InternalServerError: CreateAccountLinkInternalServerError,
        BadGatewayError: CreateAccountLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountLinkGatewayTimeoutError,
        GenericError: CreateAccountLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountTeamLink: {
        InvalidParameterError: CreateAccountTeamLinkInvalidParameterError,
        UnauthorizedError: CreateAccountTeamLinkUnauthorizedError,
        NotFoundError: CreateAccountTeamLinkNotFoundError,
        ConflictError: CreateAccountTeamLinkConflictError,
        InternalServerError: CreateAccountTeamLinkInternalServerError,
        BadGatewayError: CreateAccountTeamLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountTeamLinkGatewayTimeoutError,
        GenericError: CreateAccountTeamLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountTeamUserLink: {
        InvalidParameterError: CreateAccountTeamUserLinkInvalidParameterError,
        UnauthorizedError: CreateAccountTeamUserLinkUnauthorizedError,
        NotFoundError: CreateAccountTeamUserLinkNotFoundError,
        ConflictError: CreateAccountTeamUserLinkConflictError,
        InternalServerError: CreateAccountTeamUserLinkInternalServerError,
        BadGatewayError: CreateAccountTeamUserLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountTeamUserLinkGatewayTimeoutError,
        GenericError: CreateAccountTeamUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountUserLink: {
        InvalidParameterError: CreateAccountUserLinkInvalidParameterError,
        UnauthorizedError: CreateAccountUserLinkUnauthorizedError,
        ConflictError: CreateAccountUserLinkConflictError,
        InternalServerError: CreateAccountUserLinkInternalServerError,
        BadGatewayError: CreateAccountUserLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountUserLinkGatewayTimeoutError,
        GenericError: CreateAccountUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteAccountLink: {
        InvalidParameterError: DeleteAccountLinkInvalidParameterError,
        UnauthorizedError: DeleteAccountLinkUnauthorizedError,
        NotFoundError: DeleteAccountLinkNotFoundError,
        InternalServerError: DeleteAccountLinkInternalServerError,
        BadGatewayError: DeleteAccountLinkBadGatewayError,
        GatewayTimeoutError: DeleteAccountLinkGatewayTimeoutError,
        GenericError: DeleteAccountLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteLink: {
        InvalidParameterError: DeleteLinkInvalidParameterError,
        UnauthorizedError: DeleteLinkUnauthorizedError,
        NotFoundError: DeleteLinkNotFoundError,
        InternalServerError: DeleteLinkInternalServerError,
        BadGatewayError: DeleteLinkBadGatewayError,
        GatewayTimeoutError: DeleteLinkGatewayTimeoutError,
        GenericError: DeleteLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetLink: {
        InvalidParameterError: GetLinkInvalidParameterError,
        UnauthorizedError: GetLinkUnauthorizedError,
        NotFoundError: GetLinkNotFoundError,
        InternalServerError: GetLinkInternalServerError,
        BadGatewayError: GetLinkBadGatewayError,
        GatewayTimeoutError: GetLinkGatewayTimeoutError,
        GenericError: GetLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTarget: {
        InvalidParameterError: GetTargetInvalidParameterError,
        UnauthorizedError: GetTargetUnauthorizedError,
        NotFoundError: GetTargetNotFoundError,
        InternalServerError: GetTargetInternalServerError,
        BadGatewayError: GetTargetBadGatewayError,
        GatewayTimeoutError: GetTargetGatewayTimeoutError,
        GenericError: GetTargetGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamLink: {
        InvalidParameterError: GetTeamLinkInvalidParameterError,
        UnauthorizedError: GetTeamLinkUnauthorizedError,
        NotFoundError: GetTeamLinkNotFoundError,
        InternalServerError: GetTeamLinkInternalServerError,
        BadGatewayError: GetTeamLinkBadGatewayError,
        GatewayTimeoutError: GetTeamLinkGatewayTimeoutError,
        GenericError: GetTeamLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserLink: {
        InvalidParameterError: GetUserLinkInvalidParameterError,
        UnauthorizedError: GetUserLinkUnauthorizedError,
        NotFoundError: GetUserLinkNotFoundError,
        InternalServerError: GetUserLinkInternalServerError,
        BadGatewayError: GetUserLinkBadGatewayError,
        GatewayTimeoutError: GetUserLinkGatewayTimeoutError,
        GenericError: GetUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListLinks: {
        UnauthorizedError: ListLinksUnauthorizedError,
        InternalServerError: ListLinksInternalServerError,
        BadGatewayError: ListLinksBadGatewayError,
        GatewayTimeoutError: ListLinksGatewayTimeoutError,
        GenericError: ListLinksGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamLinks: {
        InvalidParameterError: ListTeamLinksInvalidParameterError,
        UnauthorizedError: ListTeamLinksUnauthorizedError,
        InternalServerError: ListTeamLinksInternalServerError,
        BadGatewayError: ListTeamLinksBadGatewayError,
        GatewayTimeoutError: ListTeamLinksGatewayTimeoutError,
        GenericError: ListTeamLinksGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserLinks: {
        InvalidParameterError: ListUserLinksInvalidParameterError,
        UnauthorizedError: ListUserLinksUnauthorizedError,
        InternalServerError: ListUserLinksInternalServerError,
        BadGatewayError: ListUserLinksBadGatewayError,
        GatewayTimeoutError: ListUserLinksGatewayTimeoutError,
        GenericError: ListUserLinksGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    LockAccountUserLink: {
        InvalidParameterError: LockAccountUserLinkInvalidParameterError,
        UnauthorizedError: LockAccountUserLinkUnauthorizedError,
        NotFoundError: LockAccountUserLinkNotFoundError,
        InternalServerError: LockAccountUserLinkInternalServerError,
        BadGatewayError: LockAccountUserLinkBadGatewayError,
        GatewayTimeoutError: LockAccountUserLinkGatewayTimeoutError,
        GenericError: LockAccountUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountLinkError: {
        InvalidParameterError: CreateAccountLinkInvalidParameterError,
        UnauthorizedError: CreateAccountLinkUnauthorizedError,
        ConflictError: CreateAccountLinkConflictError,
        InternalServerError: CreateAccountLinkInternalServerError,
        BadGatewayError: CreateAccountLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountLinkGatewayTimeoutError,
        GenericError: CreateAccountLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountTeamLinkError: {
        InvalidParameterError: CreateAccountTeamLinkInvalidParameterError,
        UnauthorizedError: CreateAccountTeamLinkUnauthorizedError,
        NotFoundError: CreateAccountTeamLinkNotFoundError,
        ConflictError: CreateAccountTeamLinkConflictError,
        InternalServerError: CreateAccountTeamLinkInternalServerError,
        BadGatewayError: CreateAccountTeamLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountTeamLinkGatewayTimeoutError,
        GenericError: CreateAccountTeamLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountTeamUserLinkError: {
        InvalidParameterError: CreateAccountTeamUserLinkInvalidParameterError,
        UnauthorizedError: CreateAccountTeamUserLinkUnauthorizedError,
        NotFoundError: CreateAccountTeamUserLinkNotFoundError,
        ConflictError: CreateAccountTeamUserLinkConflictError,
        InternalServerError: CreateAccountTeamUserLinkInternalServerError,
        BadGatewayError: CreateAccountTeamUserLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountTeamUserLinkGatewayTimeoutError,
        GenericError: CreateAccountTeamUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountUserLinkError: {
        InvalidParameterError: CreateAccountUserLinkInvalidParameterError,
        UnauthorizedError: CreateAccountUserLinkUnauthorizedError,
        ConflictError: CreateAccountUserLinkConflictError,
        InternalServerError: CreateAccountUserLinkInternalServerError,
        BadGatewayError: CreateAccountUserLinkBadGatewayError,
        GatewayTimeoutError: CreateAccountUserLinkGatewayTimeoutError,
        GenericError: CreateAccountUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteAccountLinkError: {
        InvalidParameterError: DeleteAccountLinkInvalidParameterError,
        UnauthorizedError: DeleteAccountLinkUnauthorizedError,
        NotFoundError: DeleteAccountLinkNotFoundError,
        InternalServerError: DeleteAccountLinkInternalServerError,
        BadGatewayError: DeleteAccountLinkBadGatewayError,
        GatewayTimeoutError: DeleteAccountLinkGatewayTimeoutError,
        GenericError: DeleteAccountLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteLinkError: {
        InvalidParameterError: DeleteLinkInvalidParameterError,
        UnauthorizedError: DeleteLinkUnauthorizedError,
        NotFoundError: DeleteLinkNotFoundError,
        InternalServerError: DeleteLinkInternalServerError,
        BadGatewayError: DeleteLinkBadGatewayError,
        GatewayTimeoutError: DeleteLinkGatewayTimeoutError,
        GenericError: DeleteLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetLinkError: {
        InvalidParameterError: GetLinkInvalidParameterError,
        UnauthorizedError: GetLinkUnauthorizedError,
        NotFoundError: GetLinkNotFoundError,
        InternalServerError: GetLinkInternalServerError,
        BadGatewayError: GetLinkBadGatewayError,
        GatewayTimeoutError: GetLinkGatewayTimeoutError,
        GenericError: GetLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTargetError: {
        InvalidParameterError: GetTargetInvalidParameterError,
        UnauthorizedError: GetTargetUnauthorizedError,
        NotFoundError: GetTargetNotFoundError,
        InternalServerError: GetTargetInternalServerError,
        BadGatewayError: GetTargetBadGatewayError,
        GatewayTimeoutError: GetTargetGatewayTimeoutError,
        GenericError: GetTargetGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamLinkError: {
        InvalidParameterError: GetTeamLinkInvalidParameterError,
        UnauthorizedError: GetTeamLinkUnauthorizedError,
        NotFoundError: GetTeamLinkNotFoundError,
        InternalServerError: GetTeamLinkInternalServerError,
        BadGatewayError: GetTeamLinkBadGatewayError,
        GatewayTimeoutError: GetTeamLinkGatewayTimeoutError,
        GenericError: GetTeamLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserLinkError: {
        InvalidParameterError: GetUserLinkInvalidParameterError,
        UnauthorizedError: GetUserLinkUnauthorizedError,
        NotFoundError: GetUserLinkNotFoundError,
        InternalServerError: GetUserLinkInternalServerError,
        BadGatewayError: GetUserLinkBadGatewayError,
        GatewayTimeoutError: GetUserLinkGatewayTimeoutError,
        GenericError: GetUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListLinksError: {
        UnauthorizedError: ListLinksUnauthorizedError,
        InternalServerError: ListLinksInternalServerError,
        BadGatewayError: ListLinksBadGatewayError,
        GatewayTimeoutError: ListLinksGatewayTimeoutError,
        GenericError: ListLinksGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamLinksError: {
        InvalidParameterError: ListTeamLinksInvalidParameterError,
        UnauthorizedError: ListTeamLinksUnauthorizedError,
        InternalServerError: ListTeamLinksInternalServerError,
        BadGatewayError: ListTeamLinksBadGatewayError,
        GatewayTimeoutError: ListTeamLinksGatewayTimeoutError,
        GenericError: ListTeamLinksGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserLinksError: {
        InvalidParameterError: ListUserLinksInvalidParameterError,
        UnauthorizedError: ListUserLinksUnauthorizedError,
        InternalServerError: ListUserLinksInternalServerError,
        BadGatewayError: ListUserLinksBadGatewayError,
        GatewayTimeoutError: ListUserLinksGatewayTimeoutError,
        GenericError: ListUserLinksGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    LockAccountUserLinkError: {
        InvalidParameterError: LockAccountUserLinkInvalidParameterError,
        UnauthorizedError: LockAccountUserLinkUnauthorizedError,
        NotFoundError: LockAccountUserLinkNotFoundError,
        InternalServerError: LockAccountUserLinkInternalServerError,
        BadGatewayError: LockAccountUserLinkBadGatewayError,
        GatewayTimeoutError: LockAccountUserLinkGatewayTimeoutError,
        GenericError: LockAccountUserLinkGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
